
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Devices_svg__Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 30.79 40.09","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"Devices_svg__st0",attrs:{"d":"M9.79 32.98h11.22v1H9.79zM9.79 36.04h11.22v1H9.79zM9.79 39.09h11.22v1H9.79zM27.64 17.79l2.94.61c.08-.38.14-.76.19-1.14l.02-.12-2.97-.39-.02.12c-.04.31-.09.62-.16.92m-2.07 4.73c-.2.28-.42.56-.64.82l2.29 1.94c.28-.33.54-.66.79-1.02l-2.44-1.74zm-20.23.22l-2.4 1.8c.26.35.53.68.82 1L6 23.55c-.23-.26-.45-.53-.66-.81m-2.37-5.71L0 17.46c.06.43.14.85.24 1.27l2.92-.68c-.08-.34-.14-.68-.19-1.02m.33-5.17c.09-.34.2-.67.32-.99L.81 9.83c-.15.4-.28.81-.4 1.23l2.89.8zM6.38 6.5c.24-.25.5-.49.76-.72L5.17 3.53c-.33.28-.64.57-.94.88L6.38 6.5zm5.27-3.24c.33-.1.67-.19 1.01-.27L12.01.06c-.42.09-.84.2-1.25.33l.89 2.87zm7.19-.07l.83-2.88c-.41-.12-.83-.22-1.25-.3l-.59 2.94c.34.06.68.14 1.01.24m2.73 16.72c-1.61 2.1-2.82 5.33-3.15 8.45l-.02.24h-2.06v-8.75l2.42-2.42-1.32-1.33-2.03 2.03-2.04-2.05-1.33 1.32 2.43 2.44v8.75h-2.1l-.02-.23c-.26-2.41-1.21-6.04-3.04-8.34-1.78-2.24-2.18-5.16-1.07-7.81 1.11-2.65 3.46-4.42 6.29-4.74 3.15-.34 6.08 1.14 7.62 3.88 1.55 2.8 1.34 6.08-.58 8.56m1.99-9.3c-1.87-3.33-5.4-5.15-9.22-4.74-3.43.38-6.27 2.52-7.6 5.72-1.34 3.2-.85 6.73 1.3 9.44 1.7 2.13 2.69 5.99 2.77 8.52.01.36.31.66.67.66h7.8c.37 0 .66-.29.68-.65.09-3.01 1.28-6.57 2.89-8.66 2.31-3 2.58-6.95.71-10.29m.62-4.3l2.11-2.13c-.31-.3-.62-.59-.96-.87l-1.92 2.3c.26.22.52.46.77.7m3.2 5.3l2.87-.87c-.13-.41-.27-.82-.42-1.22l-2.79 1.1c.12.33.23.66.34.99"}})])
          )
        }
      }
    